<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--left-4" viewBox="0 0 9 12" xmlns="http://www.w3.org/2000/svg"><path d="M8.438 11.228.806 5.973c-.226-.156-.226-.415 0-.58L8.199.304" stroke="#2A2422" stroke-miterlimit="10"/></svg>
</template>